import { staticChartKeys } from './../../constants/static-chart-keys';

export function findSum(data: Record<string, unknown>[]) {
  const sumValues = (obj: Record<string, unknown>) => {
    const numericValues = Object.entries(obj)
      .filter(([key, value]) => !staticChartKeys.includes(key) && typeof value === 'number')
      .map(([, value]) => value as number);
    return numericValues.reduce((sum, value) => sum + value, 0);
  };

  const result = data.map((obj) => {
    return {
      ...obj,
      value_column: sumValues(obj),
    };
  });

  return result;
}
